import type { EdgeType } from "./buildAccessModel";

export type EdgeLevel = "rest" | "hover" | "active";
export type EdgeVisual = { stroke: string; dash?: string };

// Edges rest quietly, darken on hover to preview a node's connections, and go
// full-contrast (text-primary) once it's selected. The dash encodes the edge
// type — solid for membership/direct, dashed for inherited, dotted for derived.
export function edgeVisual(type: EdgeType, level: EdgeLevel): EdgeVisual {
  const stroke =
    level === "active"
      ? "var(--text-primary)"
      : level === "hover"
        ? "var(--gray-600)"
        : "var(--gray-200)";
  if (type === "inherited") return { stroke, dash: "5 4" };
  if (type === "derived") return { stroke, dash: "1 2" };
  return { stroke };
}
